var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.lazy ? 'b-img-lazy' : 'b-img',{tag:"component",attrs:{"alt":_vm.alt,"blank-color":_vm.lazy ? _vm.blankColor : null,"blank-width":_vm.lazy ? _vm.width : null,"blank-height":_vm.lazy ? _vm.height : null,"src":_vm.src,"srcset":_vm.srcset,"sizes":_vm.sizes,"width":_vm.lazy ? null : _vm.width,"height":_vm.lazy ? null : _vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }